export const searchFormOption = function () {
    return [
      {
        prop: 'keyword',
        label: '关键字',
        type: 'input',
        placeholder: '请输入车架号/车牌号',
        width: '20%'
      },
      {
          prop: 'orgNo',
          label: '出单机构',
          type: 'cascader',
          placeholder: '请选择内容',
          propConfig: {
              children: 'children',
              label: 'orgName',
              value: 'id',
              checkStrictly: true,
              emitPath: false,
          },
          options: this.$store.state.app.orgList,
          width: '20%'
      },
      {
          prop: 'saleNo',
          label: '业务员',
          type: 'select',
          width: '20%',
          options: this.$store.state.app.salesmanList
      },
      // {
      //     prop: 'status',
      //     label: '状态',
      //     type: 'select',
      //     width: '20%',
      //     options: this.$emun.status
      // },
    ]
}


export default {}